import Scrollbar from 'components/Scrollbar'
import Spinner from 'components/Spinner'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import services from 'services/index'
import { Card, Footer, Head, Header } from './components'

const Group = () => {
	const role = useSelector(state => state?.user?.user?.user_type)
	const [loading, setLoading] = useState(false)
	const [data, setData] = useState([])

	const getGroups = () => {
		const options = {
			role,
			onEnd: () => setLoading(false),
			onError: () => setData([]),
			onStart: () => setLoading(true),
			onSuccess: response => {
				setData(response?.data?.results)
			},
		}

		services.groups.getGroups(options)
	}
	useEffect(() => {
		getGroups()
	}, [])
	return (
		<div className='h-full'>
			<Head />
			<Scrollbar>
				<div className='flex flex-col justify-between h-full'>
					<div className='sm:p-6 p-3'>
						<Header role={role} />
						<div className='grid grid-cols-12 gap-3'>
							{loading ? (
								<div className='h-[200px] col-span-12 flex items-center justify-center'>
									<Spinner />
								</div>
							) : (
								data?.map((item, index) => <Card key={index} {...item} />)
							)}
						</div>
					</div>
					{role === 'student' ? <Footer /> : <></>}
				</div>
			</Scrollbar>
		</div>
	)
}

export default Group
